'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _renderers = require('../renderers');

var _renderers2 = _interopRequireDefault(_renderers);

var _editor = require('../editor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jquery2.default.fn.DataTable.Api.register('column().editable()', function (rowData) {
  return (0, _editor.isEditable)(this, rowData || {});
});

/**
 * Returns name of the column.
 */
_jquery2.default.fn.DataTable.Api.register('column().name()', function () {
  return this.options().name;
});
/**
 * Returns name of the column.
 */
_jquery2.default.fn.DataTable.Api.register('column().title()', function () {
  return this.options().title;
});

/**
 * Returns options configured for the column.
 *
 * Usage:
 *
 * $('#myTable').DataTable().column(2).options();
 */
_jquery2.default.fn.DataTable.Api.register('column().options()', function () {
  return this.init().columns[this.index()];
});

/**
 * Returns object with enum values for the given column.
 *
 * Usage:
 * $('#myTable').DataTable().column(2).enumValues();
 */
_jquery2.default.fn.DataTable.Api.register('column().enumValues()', function () {
  var enums = this.init().enums || {};
  var enumName = this.options().dataType;
  return enums[enumName] || {};
});

/**
 * Get single enum value, searched by id, value, or custom predicate function.
 *
 * Usage:
 *
 * $('#myTable').DataTable().column(2).enumValue(1);
 * $('#myTable').DataTable().column(2).enumValue('New');
 * $('#myTable').DataTable().column(2).enumValues(e => e.id < 1);
 */
_jquery2.default.fn.DataTable.Api.register('column().enumValue()', function (id) {
  var e = this.enumValues();
  if (e) {
    if (typeof id === 'number') {
      return e.find(function (i) {
        return i.id === id;
      });
    } else if (typeof id === 'string') {
      return e.find(function (i) {
        return i.value === id;
      });
    } else if (typeof id === 'function') {
      // function
      return e.find(id);
    }
  }
});

/**
 * Returns object with enum values for the given column.
 *
 * Usage:
 * $('#myTable').DataTable().enumValues(2);
 */
// $.fn.DataTable.Api.register('enumValues()', function(columnSelector) {
//     const column = this.column(columnSelector);
//     return column && column.enumValues();
// });

/**
 * This API function can be used similarly to Array.prototype.map function to project columns to array of values.
 * Callback parameter is optional. If not set, function returns array of column API objects.
 *
 * Usage:
 *
 * $('#myTable').DataTable().columns().map();
 * $('#myTable').DataTable().columns().map(c => c.title());
 */
_jquery2.default.fn.DataTable.Api.register('columns().map()', function (callback) {
  var columns = this;
  if (typeof callback !== 'function') callback = function callback(c) {
    return c;
  };
  return columns.indexes().map(function (i) {
    return callback(columns.column(i));
  });
});

/**
 * Returns columns that has 'sum' option set to true.
 */
_jquery2.default.fn.DataTable.Api.register('columns().withSum()', function () {

  return this.init().columns.filter(function (x) {
    return x.sum;
  });
});

/**
 * Returns column renderer. Instance of the class derived from StringColumn (that is the most basic column type).
 */
_jquery2.default.fn.DataTable.Api.register('column().renderer()', function () {
  var column = this;
  return (0, _renderers2.default)(this.table().node(), column.options(), column.realIndex());
});

// $.fn.DataTable.Api.register('column().clearFilter()', function () {
// 	return this.search('');
// });

/**
 * Returns filter header cell
 */
_jquery2.default.fn.DataTable.Api.register('column().filter()', function () {
  return (0, _jquery2.default)(this.table().header()).find('tr.column-filters th:nth-child(' + (this.realIndex() + 1) + ')');
});

/**
 * Returns sum header cell
 */
_jquery2.default.fn.DataTable.Api.register('column().sumCell()', function () {
  return (0, _jquery2.default)(this.table().header()).find('tr.column-sums th:nth-child(' + (this.realIndex() !== null ? this.realIndex() + 1 : 0) + ')');
});

/**
 * Returns column API based on filter element. Filter element can be any element inside table header cell (TH),
 * including TH itself.
 */
_jquery2.default.fn.DataTable.Api.register('columnByFilter()', function (filterElement) {
  var $th = (0, _jquery2.default)(filterElement).closest('th');
  return this.column($th.closest('thead').find('tr:first th:nth-child(' + ($th.index() + 1) + ')'));
});

/**
 * Returns real index
 */
_jquery2.default.fn.DataTable.Api.register('column().realIndex()', function () {
  return this.colReorder.transpose(this.index('visible'));
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/api/column-extensions.js
// module id = 1106
// module chunks = 1